interface Props {
  margin: number
  intervals: number
  cellHeight: number
  lineGapY: number
  daysToShow: number
  dayWidth: number
  gapsWidth: number
}

export const TimeLines = ({
  intervals,
  margin,
  cellHeight,
  lineGapY,
  daysToShow,
  dayWidth,
  gapsWidth,
}: Props) =>
  [...Array(intervals)].map((_, i) => (
    <line
      key={i}
      x1={margin}
      y1={i * cellHeight + lineGapY}
      x2={margin + daysToShow * dayWidth + gapsWidth}
      y2={i * cellHeight + lineGapY}
      stroke="#e9e9e9"
      strokeWidth="1"
    />
  ))
